export const LAST_GIFT_DATE_GTE_FILTER = 'prospects_last_gift_date_gte_filter';
export const LAST_GIFT_DATE_LTE_FILTER = 'prospects_last_gift_date_lte_filter';
export const GIFT_BUCKET_FILTER = 'prospects_gift_bucket_filter';
export const GIFT_DATE_BUCKET_FILTER = 'prospects_gift_date_bucket_filter';
export const PROVINCE_STATE_FILTER = 'prospects_province_filter';
export const COUNTRY_FILTER = 'prospects_country_filter';
export const TYPE_FILTER = 'prospects_type_filter';
export const POSTAL_CODE_FILTER = 'prospects_postal_code_filter';
export const RECENT_GIFT_MONTH_FILTER = 'prospects_recent_gift_month_filter';
export const UNASSIGNED_DONORS_FILTER = 'prospects_unassigned_donors_filter';

export const fundraisersInitialState = {
	me: null,
	entities: {},
	fetching: [],
};

// This is for the main prospect page.
export const prospectsFiltersClearedState = {
	[LAST_GIFT_DATE_GTE_FILTER]: null,
	[LAST_GIFT_DATE_LTE_FILTER]: null,
	[GIFT_BUCKET_FILTER]: [],
	[GIFT_DATE_BUCKET_FILTER]: [],
	[PROVINCE_STATE_FILTER]: [],
	[COUNTRY_FILTER]: [],
	[TYPE_FILTER]: [],
	[POSTAL_CODE_FILTER]: [],
	[UNASSIGNED_DONORS_FILTER]: { value: {}, label: 'Complete List' },
};



// WEBPACK FOOTER //
// ./src/redux/fundraisers/fundraiser.initialState.js